export default "__VITE_ASSET__BAKvORh5__"